import { render, staticRenderFns } from "./TicketAdd.vue?vue&type=template&id=2a2e1a1b&scoped=true&"
import script from "./TicketAdd.vue?vue&type=script&lang=js&"
export * from "./TicketAdd.vue?vue&type=script&lang=js&"
import style0 from "./TicketAdd.vue?vue&type=style&index=0&id=2a2e1a1b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e1a1b",
  null
  
)

export default component.exports